import { render, staticRenderFns } from "./GeneralHealthPlate.vue?vue&type=template&id=5b09a7eb&scoped=true&"
import script from "./GeneralHealthPlate.vue?vue&type=script&lang=js&"
export * from "./GeneralHealthPlate.vue?vue&type=script&lang=js&"
import style0 from "./GeneralHealthPlate.vue?vue&type=style&index=0&id=5b09a7eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09a7eb",
  null
  
)

export default component.exports